import React, { Component, Fragment }                                      from "react"
import Responsive                                                from "react-responsive"
import { observer }                                              from "mobx-react"
import { Button, Container, Dropdown, Icon, Image, Menu, Modal, Input, Table, MenuMenu } from "semantic-ui-react"
import { Link, NavLink }                                         from "react-router-dom"
import CartButton                                                from "components/Cart/CartButton"
import CartTotalMinimum                                          from "components/Cart/CartTotalMinimum"
import shop                                                      from "shop/shop"
import MenuBySlug                                                from "components/Menu/MenuBySlug"
import htmr                                                                           from "htmr";
import languageStore               from "stores/languageStore"
import app                         from "app.controller"
import "style/header.scss"
import searchStore                 from "stores/searchStore"
// import { SearchForm }              from "components/Search/SearchBarWithOptions"
import { SearchForm }              from "components/Search/SearchBarWithTypeahead"
import categoryStore               from "stores/categoryStore"
import { useLocation, withRouter } from "react-router"
import Typeahead                   from "../../../../components/Typeahead/Typeahead";
import settingStore from "stores/settingStore"
import { select } from "notie"
import WordPressShopComponent from "../../../../components/WordPressShopComponent/WordPressShopComponent";
import { max } from "lodash"
import Price from "components/Price/Price"
import LoginLinkHover from "components/LoginLinkHover"
import ImageWithFallback from "components/ImageWithFallback"
import queryString from "qs"
import swal from "sweetalert2"
import "sweetalert2/dist/sweetalert2.min.css"
import $fetch from "sdk/$fetch"

// import Navigation from "../Navigation/Navigation"
@observer
export default class Header extends Component {
  
  constructor() {
    super()
    this.state = {
      list: shop.orderlist.default,
      categoryData: false,
      chooseOrderMode: settingStore.get("orderMode") === "laboratory" || settingStore.get("orderMode") === "medicine" ? false : true,
      orderModeChosen: settingStore.get("orderMode"),
      siderbarActive: false,
      megaMenuActive: false,
      megaMenuActiveMini: false,
    }
  }
  
  componentDidMount() {
    shop.events.loaded.add( this.handleLoad )
    //shop.orderlist.default.events.change.add( this.handleOrderlist )
  }
  
  handleOrderlist = ( { list } ) => {
    this.setState( {
                     list
                   } )
  }
  
  handleLoad = () => {
    this.setState( {
                     categoryData: shop.categories
                   } )
  }
  
  componentWillUnmount() {
    //shop.orderlist.default.events.change.remove( this.handleOrderlist )
    shop.events.loaded.remove( this.handleLoad )
  }
  
  render() {
    const { showMini, chooseOrderMode, orderModeChosen, siderbarActive, megaMenuActive, megaMenuActiveMini } = this.state
    return (
      <header className={`header ${showMini}`}>
        {/*<OrderMode orderModeChosen={orderModeChosen} onClose={() => this.setState({ chooseOrderMode: false })}/>*/}

        <Responsive maxWidth={790}>
          <div>
            {showMini && shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "QuickOrderPlus" && <MiniHeaderMobileQuickOrder/> }
            {showMini && shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme !== "QuickOrderPlus" && <MiniHeaderMobile/> }
            <OnOffset
              offset={95}
              onPassedReverse={() => {
                this.setState( { showMini: false } )
              }}
              onPassed={() => {
                console.log( "scrolled" )
                this.setState( { showMini: "scrolled" } )
              }}>
              {shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "QuickOrderPlus" ? <MobileHeaderQuickOrder/> : <MobileHeader/>}
            </OnOffset>
          </div>
        </Responsive>
        <Responsive minWidth={790}>
          <div>
            {console.log("showMini", showMini, "shop.config.plugin.HeaderV4", shop.config.plugin.HeaderV4)}
            {showMini && !shop.config.plugin.HeaderV4 && <MiniHeader onMegaMenuToggle={() => this.setState({ megaMenuActiveMini: !megaMenuActiveMini })} megaMenuActiveMini={megaMenuActiveMini}/>}
            <OnOffset
              offset={95}
              onPassedReverse={() => {
                this.setState( { showMini: false } )
              }}
              onPassed={() => {
                console.log( "scrolled" )
                this.setState( { showMini: "scrolled" } )
                this.setState({ megaMenuActive: false })
              }}>
              <DesktopHeader orderModeChosen={orderModeChosen} onClose={() => this.setState({ chooseOrderMode: false })} 
              siderbarActive={siderbarActive} onSidebarToggle={() => this.setState({ siderbarActive: !siderbarActive })}
              onMegaMenuToggle={() => this.setState({ megaMenuActive: !this.state.megaMenuActive })} megaMenuActive={megaMenuActive}/>
            </OnOffset>
          </div>
        </Responsive>

      </header>
    )
  }
}

class MobileHeader extends Component {
  render() {
    const { inverted = false } = this.props

    return (
      <div className="MobileHeader ">
        {/*        <div className="" style={{ backgroundColor: "#a2cf66"}} >
          <Container className="flex flex-row justify-between items-center" >
            <SettingsMenu  attached/>
          </Container>
        </div> */}
        <div className="pa1 ph2 ph2-ns pt3-ns pb3-ns mini-header-static">
          <div className="flex flex-row justify-between items-center ">
            <div className={"w-70 flex flex-row justify-start pr4 pb3 pt3"}>
              <Button className="ButtonFooter" as="a"><Icon className="IconCss" onClick={app.sidebarLeft.toggle.dispatch} name="big bars" /></Button>
              {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
              <Button className="ButtonFooter" as={Link} to={`/account/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big user circle" /></Button>}
              {((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) &&
              <Button className="ButtonFooter" as={Link} to={`/login/?referrer=${document.location.pathname}`}><Icon className="IconCss"  name="big user circle" /></Button>}
            </div>
            
            <div className={"w-100 flex flex-row items-center justify-center"}>
            <Image className="pt3"  style={{height: "60px", width: "60px"}} as={Link} to={"/home/"} src={shop.config.logo} />
            </div>
            
            <div className={"w-70 flex flex-row justify-end items-center pr4 pb3 pt3"}>
              {/*<Search />*/}
              <Button className="ButtonFooter" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
              <Button className="ButtonFooter"  as={Link}
              {...this.props}
										to={{
											pathname: shop.session ? `/checkout/` : `/login/`,
											search  : queryString.stringify( {referer: document.location.pathname} )
										}}><Icon className="IconCss" name="big shopping cart" /></Button>
             </div>
          </div>
        </div>
      </div>
    )
  }
}

class MobileHeaderQuickOrder extends Component {
  render() {
    const { inverted = false } = this.props
      return (
        <div className="MobileHeader_QuickOrderPlus">
                    <Container className="QuickOrderPlusHeader_Container" >
            <div className="QuickOrderPlusHeader_Container">
              <Link to={`/quickorder/`}>
              <ImageWithFallback className="QuickOrderPlusHeader_Logo" style={{width: "150px"}} src={shop.config.logo} fallback={"/trendsoft_logo_neue_farbe.png"} />
              </Link>
              {shop.session && <div><Link to={`/account/`}>
              <Button
              style={{ backgroundColor: "transparent", width: "45px",  height: "45px", borderRadius: "0px", alignContent: "center", display: "flex", alignItems: "center"}}
            >
              <div className=" fw5 f5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-60 large user circle" />
                
              </div>
            </Button></Link></div>}
                            {shop.session && <div><Link to={`/quickorder/`}>
              <Button
              style={{ backgroundColor: "transparent", width: "45px",  height: "45px", borderRadius: "0px", alignContent: "center", display: "flex", alignItems: "center"}}
            >
              <div className=" fw5 f5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-60 large shopping bag" />
                
              </div>
            </Button></Link></div>}
            {shop.session && <div>
              <Button           {...this.props}
                        as={Link}  to={`/checkout/?referer=${document.location.pathname}`}
              style={{ backgroundColor: "transparent", width: "45px",  height: "45px", borderRadius: "0px", alignContent: "center", display: "flex", alignItems: "center"}}
            >
              <div className=" fw5 f5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-60 large shopping basket" />
                
              </div>
            </Button></div>}
            </div>

          </Container>
        </div>
      )
   }
}

const SettingsMenu = observer(
  ( props ) => {
    const { currentLanguage } = languageStore
    const headerPlugin = shop.config.plugin.HeaderV2 ? "HeaderV2" : shop.config.plugin.HeaderV3 ? "HeaderV3" : "HeaderV1"
    return (
      <Menu secondary style={{border: "none"}}
        className=""
        borderless
        fluid
        {...props}
        size="small">
      {/* LEFT SIDE MENU */}
      <Menu.Item>
         {/*<div className="flex flex-row justify-between items-start "> <img src={"/image/Icon_Kontakt.jpg"} alt="Kontakt" style={{width: "80px", height: "auto"}} />
         <div className="flex flex-column justify-start items-start">
          <p className="pl2 ">{htmr(translate("<b className=\"cssOptima\">Haben Sie eine Frage oder möchten Sie ein Display bestellen?</b><br/>Gerne können Sie sich direkt bei unserer<br/> Customer-Sales-Abteilung melden<br/>0241 881 7703 | customer-sales-de@lindt.com"))} </p>
         </div>
         </div> */}
      </Menu.Item>
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Menu.Item
        position=" right "
        as={Link}
        to="/orderlist/" ><Icon style={{color: headerPlugin === "HeaderV2" ? "#343f27" : "white"}} name={headerPlugin === "HeaderV2" ? "heart" : "white heart"}/> <div className={headerPlugin === "HeaderV2" ? "cssLuchtColor" : "white"}>{translate( "Orderlist" )}</div></Menu.Item>}
      
      {/* RIGHT SIDE MENU*/}

      {/*(shop.session && shop.session.handId) && <Menu.Item><div className="white"
        as={Link}
        to="/login/accounts/">{translate( "Clients" )}</div></Menu.Item>*/}
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<Menu.Item
        as={Link}
        to="/quickorder/"><Icon style={{color: headerPlugin === "HeaderV2" ? "#343f27" : "white"}} name={headerPlugin === "HeaderV2" ? "shopping basket" : "white shopping basket"}/><div className={headerPlugin === "HeaderV2" ? "cssLuchtColor" : "white"}>{translate( "Quickorder" )}</div></Menu.Item>}
      
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Menu.Item
        as={Link}
        to="/account/"><Icon style={{color: headerPlugin === "HeaderV2" ? "#343f27" : "white"}} name={headerPlugin === "HeaderV2" ? "user" : "white user"}/><div className={headerPlugin === "HeaderV2" ? "cssLuchtColor" : "white"}>{translate( "My Account" )}</div></Menu.Item>}
      {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Menu.Item
        as={Link}
        to="/logout/"><Icon style={{color: headerPlugin === "HeaderV2" ? "#343f27" : "white"}} name={headerPlugin === "HeaderV2" ? "power off" : "white power off"}/><div className={headerPlugin === "HeaderV2" ? "cssLuchtColor" : "white"}>{translate( "Logout" )}</div></Menu.Item>}
      
      {/*!shop.session && <LoginLink/> */}
      
      {/*shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/> */}
      {!shop.session && <Menu.Item position=" right "
        as={Link}
        to="/login/"><Icon style={{color: headerPlugin === "HeaderV2" ? "#343f27" : "white"}} name={headerPlugin === "HeaderV2" ? "power off" : "white power off"}/><div className={headerPlugin === "HeaderV2" ? "cssLuchtColor" : "white"}>{translate( "Anmelden" )}</div></Menu.Item>}
      
      {languageStore.available.length > 1 && <Menu.Item position=" right "><Dropdown  style={{ width: "auto", color: headerPlugin === "HeaderV2" ? "black-60 " : "white"}} text={currentLanguage.toUpperCase()}
                               pointing
                               className="link item right floated">
        <Dropdown.Menu>
        {languageStore.available.map( locale => <Dropdown.Item  
          key={locale}
          onClick={() => languageStore.setLanguage( locale )}><p className={headerPlugin === "HeaderV2" ? "black-60" : "black-60"}>{locale}</p></Dropdown.Item> )}
        </Dropdown.Menu>
      </Dropdown></Menu.Item>}
      </Menu>
    )
  }
)

function LoginLink() {
  const location = useLocation()
  return <Fragment>
      {!shop.session && <Menu.Item position="right" className={"primary"}>
        <Table style={{ backgroundColor: "transparent" }} basic="very" compact>
          <tbody>
            <tr>
              <td>
                <Button
                  style={{ minWidth: "280px", height: "35px", borderRadius: "25px" }}
                  as={Link}
                  to={`/login/?referrer=${document.location.pathname}login`}
                  primary
                >
                  <Icon name={"white power off"}/>{translate( "Bestandskunden anmelden" )}
                </Button>
              </td>
            </tr>
            <tr>
              <td>
                <Button
                  style={{ minWidth: "280px", height: "35px", borderRadius: "25px" }}
                  as={Link}
                  to={`/login/?referrer=${document.location.pathname}register`}
                  primary
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon name={"white file text"}/>{translate( "Neukundenanmeldung" )}
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </Menu.Item>}
    </Fragment>
}



@observer
class DesktopHeader extends Component {

  state = {
    siderbarActive: false,
  }

  render() {
    const { chooseOrderMode, onClose, orderModeChosen, onSidebarToggle, onMegaMenuToggle, megaMenuActive } = this.props;
    const { siderbarActive } = this.state;
    console.log("shop.config.logo sidebar",shop.config.plugin.HeaderV2, siderbarActive, " MEGAMENU" ,megaMenuActive)
    if(shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "QuickOrderPlus"){
      console.log("Rendering Header for QuickOrderPlus")
      return (
        <div className="QuickOrderPlusHeader">

                  <OnOffset
          offset={95}
          onPassedReverse={() => {
            this.setState( { showMini: false } )
          }}
          onPassed={() => {
            this.setState( { showMini: "scrolled" } )
          }}></OnOffset>
          <Container className="QuickOrderPlusHeader_Container" >
            <div className="QuickOrderPlusHeader_Container"><Link to={`/quickorder/`}><ImageWithFallback className="QuickOrderPlusHeader_Logo" style={{width: "250px", height: "30px"}} src={shop.config.logo} fallback={"/trendsoft_logo_neue_farbe.png"} /></Link>
              {shop.session && <div><Link to={`/account/`}>
              <Button
              style={{
                backgroundColor: "#929292",
                width: "180px",
                height: "45px",
                borderRadius: "0px",
                alignContent: "center",
                display: "flex",
                alignItems: "center",
                transition: "background 0.2s",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"
              }}
              primary
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor = "#8fc75f"; // 20% darker than #a2cf66
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor = "#929292";
              }}
            >{/*() => onSidebarToggle() */}
              <div className=" fw5 f5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="pr2" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="user circle" />
                {translate("Account")}
              </div>
            </Button></Link></div>}
                            {shop.session && <div><Link to={`/quickorder/`}>
              <Button
              style={{
                backgroundColor: "#929292",
                width: "180px",
                height: "45px",
                borderRadius: "0px",
                alignContent: "center",
                display: "flex",
                alignItems: "center",
                transition: "background 0.2s",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"
              }}
              primary
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor = "#8fc75f"; // 20% darker than #a2cf66
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor = "#929292";
              }}
            >{/*() => onSidebarToggle() */}
              <div className=" fw5 f5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="pr2" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="shopping bag" />
                {translate("Quickorder")}
              </div>
            </Button></Link></div>}
              {shop.session && <div><CartButton style={{backgroundColor: "#a2cf66", width: "180px", height: "45px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></div>}
            </div>

          </Container>
        </div>
      )
    }
    else{
    if(shop.config.plugin.HeaderV4){
      return (<div className="mini-header">
    <div className="ph2">
      <Container className="flex flex-row justify-end items-end pa3" >
          <div className="flex flex-row justify-between items-center mini-header-div" style={{borderRadius: "0px", backgroundColor: "#ffffff",  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.4)"}}  >
                        <div className="raederHeaderMenu">
            {/* LEFT SIDE MENU */}

            <div className="flex flex-row justify-between items-between">
              <Button primary id="buttonHeaderRaederLeftSide"><p className="f4 fw5 black-70">{translate("Produkte")}</p></Button>
              <Button primary id="buttonHeaderRaederLeftSide"><p className="f4 fw5 black-70">{translate("Stories")}</p></Button>
              <Button primary id="buttonHeaderRaederLeftSide"><p className="f4 fw5 black-70">{translate("Service")}</p></Button>
              <Button primary id="buttonHeaderRaederLeftSide"><p className="f4 fw5 black-70">{translate("Marke")}</p></Button>
            </div>
                        <div>
            <NavLink to="/home/" className={""}>
                    <div className="pt2 pb2"><img style={{maxHeight: "30px"}}
                      src={"/trendsoft_logo_neue_farbe.png"}
                      alt="zur Startseite"/></div>
                  </NavLink>
                  {console.log("shop.config.logo",shop.config)}
            </div>
            {/*<div style={{ display: "flex", alignItems: "center", position: "relative" }}
            onMouseEnter={shop.config.plugin.categoryHeaderDropdown ? () => { if(!megaMenuActive) onMegaMenuToggle(); } : undefined}
            onMouseLeave={shop.config.plugin.categoryHeaderDropdown ? () => { if(megaMenuActive) onMegaMenuToggle(); } : undefined}
            >
              <Button
                style={{
                  backgroundColor: "transparent",
                  minWidth: "150px",
                  maxWidth: "200px",
                  height: "40px",
                  borderRadius: "0px",
                  alignContent: "center",
                  display: "flex",
                  alignItems: "center",
                  transition: "background 0.2s",
                  boxShadow: "none"
                }}
                primary
                onMouseOver={e => {
                  e.currentTarget.style.backgroundColor = "#f1f1f1ff"; // 20% darker than #a2cf66
                }}
                onMouseOut={e => {
                  e.currentTarget.style.backgroundColor = "transparent";
                }}
                onClick={shop.config.plugin.categoryHeaderDropdown ? onMegaMenuToggle : app.sidebarLeft.toggle.dispatch}
              >
                <div className="black-50 fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                  <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-50  bars" />
                  {translate("Alle Kategorien")}
                </div>
              </Button>
              {shop.config.plugin.categoryHeaderDropdown && megaMenuActive && <div
                style={{ position: "absolute", top: "100%", left: 0 }}
              ><MegaMenuBigDropDown miniHeader={true}/></div>}
            </div>*/}

            {/*<Responsive minWidth={900}>
            {<div style={{borderRadius: "50px"}}
              position="right">
                  <div className="tc " style={{borderRadius: "0px",border: "1px solid #c9c9c9ff",}}>                       <SearchForm
                    style={{ width: "200px", }}
                    className={"mw6 w-100 "}
                    value={searchStore.searchTerm}
                    onChange={e => {
                      searchStore.setSearchTerm( e.target.value )
                    }} icon="search" placeholder={translate( "Suche" ) + "..."}/></div>
              </div>}
                </Responsive> */}

            
            {/* RIGHT SIDE MENU*/} {/*ICONS FOR RAEDER: https://phosphoricons.com/?weight=light&q=heart */}
            <div className="flex flex-row justify-between items-between">
              <Button primary id="buttonHeaderRaederRightSide" as={Link} to={`/search/?referrer=${document.location.pathname}`}>
                <p><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z"></path></svg>
                </p></Button>
              <Button primary id="buttonHeaderRaederRightSide" as={Link} to={`/account/?referrer=${document.location.pathname}`}>
                <p><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M229.19,213c-15.81-27.32-40.63-46.49-69.47-54.62a70,70,0,1,0-63.44,0C67.44,166.5,42.62,185.67,26.81,213a6,6,0,1,0,10.38,6C56.4,185.81,90.34,166,128,166s71.6,19.81,90.81,53a6,6,0,1,0,10.38-6ZM70,96a58,58,0,1,1,58,58A58.07,58.07,0,0,1,70,96Z"></path></svg>
              </p></Button>
              <Button primary id="buttonHeaderRaederRightSide" as={Link} to={`/orderlist/?referrer=${document.location.pathname}`}><p>
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M178,42c-21,0-39.26,9.47-50,25.34C117.26,51.47,99,42,78,42a60.07,60.07,0,0,0-60,60c0,29.2,18.2,59.59,54.1,90.31a334.68,334.68,0,0,0,53.06,37,6,6,0,0,0,5.68,0,334.68,334.68,0,0,0,53.06-37C219.8,161.59,238,131.2,238,102A60.07,60.07,0,0,0,178,42ZM128,217.11C111.59,207.64,30,157.72,30,102A48.05,48.05,0,0,1,78,54c20.28,0,37.31,10.83,44.45,28.27a6,6,0,0,0,11.1,0C140.69,64.83,157.72,54,178,54a48.05,48.05,0,0,1,48,48C226,157.72,144.41,207.64,128,217.11Z"></path></svg>
              </p></Button>
              <Button primary id="buttonHeaderRaederRightSide" as={Link} to={`/checkout/?referrer=${document.location.pathname}`}>
                <p><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256"><path d="M228.61,60.16A6,6,0,0,0,224,58H61L54.63,22.93A6,6,0,0,0,48.73,18H24a6,6,0,0,0,0,12H43.72L69.53,171.94a21.93,21.93,0,0,0,6.24,11.77A26,26,0,1,0,113.89,190h52.22A26,26,0,1,0,188,178H91.17a10,10,0,0,1-9.84-8.21L77.73,150H196.1a22,22,0,0,0,21.65-18.06L229.9,65.07A6,6,0,0,0,228.61,60.16ZM106,204a14,14,0,1,1-14-14A14,14,0,0,1,106,204Zm96,0a14,14,0,1,1-14-14A14,14,0,0,1,202,204Zm3.94-74.21A10,10,0,0,1,196.1,138H75.55L63.19,70H216.81Z"></path></svg>
              </p></Button>

            {/*
                        <div style={{borderRadius: "50px"}}>
                <Button className="ButtonHeader" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
              </div>
            shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<div>
              <CartButton style={{backgroundColor: "#a2cf66", width: "auto", height: "40px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></div>*/}

            
            {/*!shop.session && <LoginLink/>*/}
            {/*!shop.session && <div> <LoginLinkHover located={"HeaderMenu"}/></div> */}
            {/*shop.session && <Menu.Item><CartTotalMinimum located={"HeaderMenu"}/></Menu.Item>*/}
            {/*shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/> */}
            </div>
            </div>
          </div>
        </Container>
    </div>
  </div>)
    }
    if(shop.config.plugin.HeaderV1){
          return (
      <div >
        <div className="" style={{ backgroundColor: "#646363ff"}} >
          <Container className="flex flex-row justify-between items-center" >

            <SettingsMenu  attached/>
          </Container>
        </div>
        
        <OnOffset
          offset={95}
          onPassedReverse={() => {
            this.setState( { showMini: false } )
          }}
          onPassed={() => {
            this.setState( { showMini: "scrolled" } )
          }}>

        <div className="pt2 pb3" style={{backgroundColor: "#646363ff", }} >
          <Container className="flex flex-row justify-between items-center mb3"  style={{ borderRadius: "0px", backgroundColor: "#ffffff",  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.4)",  zIndex: 1000}} >
          <Menu secondary 
            borderless
            fluid
            size="small">
          {/* LEFT SIDE MENU */}
          <Menu.Item>
          <NavLink to="/home/" className={"Logo"}>
                  <div className="pt2"><img style={{height: "80px", width: "250px"}}
                    src={"/trendsoft_logo_neue_farbe.png"}
                    alt="zur Startseite"/></div>
                </NavLink>
                {console.log("shop.config.logo",shop.config)}
          </Menu.Item>
          {/*<Menu.Item>
            <Menu.Item>
            <table>
              <tbody>
                <tr>
                  <td className="white pb2 f5 tc">
                    Order Mode
                  </td>
                  <td className="white pb2 f5">
                    wählen:
                  </td>
                </tr>
                <tr>
                  <td className="">
                    {console.log("shop.chooseOrderMode",shop.chooseOrderMode)}
                  <Button className="buttonLaboratory" 
                  style={{border: "1px solid #ffffff",
                     backgroundColor: settingStore.get("orderMode") === "laboratory" ? "#a2cf66" : "ffffff",
                    color: settingStore.get("orderMode") === "laboratory" ? "#ffffff" : "#111111",

                  }} onClick={() => { 
              shop.chooseOrderMode = "laboratory"; 
              settingStore.set("orderMode", "laboratory")
              this.setState({ buttonClicked: true });
              this.setState({ orderModeChosen: "laboratory" });
              document.querySelector('.buttonLaboratory').style.backgroundColor = '#a2cf66';
              document.querySelector('.buttonLaboratory').style.color = ' #ffffff';
              document.querySelector('.buttonMedicine').style.backgroundColor = '#ffffff';
              document.querySelector('.buttonMedicine').style.color = ' #111111';
              onClose(); 
            }} ><p className="fw9">Labor</p></Button>
                  </td>
                  <td>
                  <Button className="buttonMedicine" style={{border: "1px solid #ffffff",
                     backgroundColor: settingStore.get("orderMode") === "medicine" ? "#a2cf66" : "ffffff",
                    color: settingStore.get("orderMode") === "medicine" ? "#ffffff" : "#111111",
                    
                  }}  onClick={() => { 
              shop.chooseOrderMode = "medicine"; 
              settingStore.set("orderMode", "medicine")
              this.setState({ buttonClicked: true });
              this.setState({ orderModeChosen: "medicine" });
              document.querySelector('.buttonLaboratory').style.backgroundColor = '#ffffff';
              document.querySelector('.buttonLaboratory').style.color = ' #111111';
              document.querySelector('.buttonMedicine').style.color = ' #ffffff';
              document.querySelector('.buttonMedicine').style.backgroundColor = '#a2cf66';
              onClose(); 
            }}><p className="fw9">Medizin</p></Button>
                  </td>
                </tr>
              </tbody>
            </table>
            </Menu.Item>
          </Menu.Item>*/}
          {<Menu.Item style={{ display: "flex", alignItems: "center", position: "relative" }}
            onMouseEnter={shop.config.plugin.categoryHeaderDropdown ? () => { if(!megaMenuActive) onMegaMenuToggle(); } : undefined}
            onMouseLeave={shop.config.plugin.categoryHeaderDropdown ? () => { if(megaMenuActive) onMegaMenuToggle(); } : undefined}
          >
            <Button
              style={{
                backgroundColor: "#a2cf66",
                minWidth: "150px",
                maxWidth: "200px",
                height: "40px",
                borderRadius: "0px",
                alignContent: "center",
                display: "flex",
                alignItems: "center",
                transition: "background 0.2s",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"
              }}
              primary
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor = "#8fc75f"; // 20% darker than #a2cf66
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor = "#a2cf66";
              }}
              onClick={shop.config.plugin.categoryHeaderDropdown ? () => onMegaMenuToggle() : app.sidebarLeft.toggle.dispatch}
            >{/*() => onSidebarToggle() */}
              <div className=" fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="white  bars" />
                {translate("Alle Kategorien")}
              </div>
            </Button>
            {shop.config.plugin.categoryHeaderDropdown && megaMenuActive && <div
              style={{
                backgroundColor: "transparent",
                position: "absolute",
                top: "100%",
                left: 0,
              }}
            ><MegaMenuBigDropDown /></div>}
          </Menu.Item>}
          <Responsive maxWidth={899}>
            <Menu.Item style={{borderRadius: "50px"}}>
              <Button className="ButtonHeader" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
            </Menu.Item>
          </Responsive>
          <Responsive minWidth={900}>
          {<Menu.Item style={{borderRadius: "50px"}}
            position="right">
                <div className="tc " style={{borderRadius: "0px", border: "none"}}>                       <SearchForm
                  style={{ width: "200px", }}
                  className={"mw6 w-100 "}
                  value={searchStore.searchTerm}
                  onChange={e => {
                    searchStore.setSearchTerm( e.target.value )
                  }} icon="search" placeholder={translate( "Suche" ) + "..."}/></div>
            </Menu.Item>}
              </Responsive>

          
          {/* RIGHT SIDE MENU*/}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<Menu.Item>
            <CartButton style={{backgroundColor: "#a2cf66", width: "auto", height: "40px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></Menu.Item>}

          
          {/*!shop.session && <LoginLink/>*/}
          {!shop.session && <Menu.Item> <LoginLinkHover located={"HeaderMenu"}/></Menu.Item>}
          {/*shop.session && <Menu.Item><CartTotalMinimum located={"HeaderMenu"}/></Menu.Item>*/}
          {/*shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/>*/}

          </Menu>
          </Container>
        </div>

        </OnOffset>
        {/*<MenuUtility list={list}/>*/}
        {/*<MegaMenuBig /> */}
      </div>
    )
    }
    if(shop.config.plugin.HeaderV2){
          return (
      <div >
        {<div className="" style={{ backgroundColor: "#ffffffff", border: "none"}} >
          <Container className="flex flex-row justify-between items-center" >

            <SettingsMenu  attached/>
          </Container>
        </div>}
        
        <OnOffset
          offset={95}
          onPassedReverse={() => {
            this.setState( { showMini: false } )
          }}
          onPassed={() => {
            this.setState( { showMini: "scrolled" } )
          }}>

        <div className="pt3 pb3" style={{}} >
          <Container className=""  style={{  zIndex: 1000}} >
          <div secondary  className="headerMenuLindt" 
            >
          {/* LEFT SIDE MENU */}
          <div>
          <NavLink to="/home/" className={"Logo"}>
                  <div className="pt2"><img style={{width: "180px"}}
                    src={shop.config.logo}
                    alt="zur Startseite"/></div>
                </NavLink>
                {console.log("shop.config.logo",shop.config)}
          </div>

          {<div style={{ display: "flex", alignItems: "center", position: "relative" }}
            onMouseEnter={shop.config.plugin.categoryHeaderDropdown ? () => { if(!megaMenuActive) onMegaMenuToggle(); } : undefined}
            onMouseLeave={shop.config.plugin.categoryHeaderDropdown ? () => { if(megaMenuActive) onMegaMenuToggle(); } : undefined}
          >
            {/*            <Button
              className="categoryMenuButton"
              primary
              onClick={shop.config.plugin.categoryHeaderDropdown ? () => onMegaMenuToggle() : app.sidebarLeft.toggle.dispatch}
            >
              <div className="black-50 fw4 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-50 bars" />
                {translate("Alle Kategorien")}
              </div>
            </Button> */}
            {shop.config.plugin.categoryHeaderDropdown && megaMenuActive && <div
              style={{
                backgroundColor: "transparent",
                position: "absolute",
                top: "100%",
                left: 0,
              }}
            ><MegaMenuBigDropDown /></div>}
          </div>}
          <Responsive maxWidth={899}>
            <div style={{borderRadius: "50px"}}>
              <Button className="ButtonHeader" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
            </div>
          </Responsive>
          <Responsive minWidth={900}>
          {<div className="headerMenuLindtSearch" style={{borderRadius: "50px"}}
            position="right">
                <div className="tc " style={{}}><SearchForm
                  style={{ width: "200px", }}
                  className={"mw6 w-100 "}
                  value={searchStore.searchTerm}
                  onChange={e => {
                    searchStore.setSearchTerm( e.target.value )
                  }} icon="search" placeholder={translate( "Suche" ) + "..."}/></div>
            </div>}
              </Responsive>

          
          {/* RIGHT SIDE MENU*/}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<div>
            <CartButton style={{background: "#343f27", width: "auto", height: "40px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></div>}

          
          {/*!shop.session && <LoginLink/>*/}
          {!shop.session && <div> <LoginLinkHover located={"HeaderMenu"}/></div>}
          {/*shop.session && <Menu.Item><CartTotalMinimum located={"HeaderMenu"}/></Menu.Item>*/}
          {/*shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/>*/}

          </div>
          </Container>
        </div>
        <div className=" "><MegaMenuBig /></div>
        </OnOffset>
        {/*<MenuUtility list={list}/>*/}
        {/*<MegaMenuBigDropDown /> */}
      </div>
    )
    }
    if(shop.config.plugin.HeaderV3){
      return (      <div >
        {shop.session && <div className="" style={{ backgroundColor: "#ffffffff"}} >
          <Container className="flex flex-row justify-between items-center" >

            <SettingsMenu  attached/>
          </Container>
        </div>}
        
        <OnOffset
          offset={95}
          onPassedReverse={() => {
            this.setState( { showMini: false } )
          }}
          onPassed={() => {
            this.setState( { showMini: "scrolled" } )
          }}>

        <div className="pt3 pb3" style={{}} >
          <Container className="flex flex-row justify-between items-center"  style={{  zIndex: 1000}} >
          <Menu secondary 
            borderless
            fluid
            size="small">
          {/* LEFT SIDE MENU */}
          <Menu.Item>
          <NavLink to="/home/" className={"Logo"}>
                  <div className="pt2"><img style={{height: "65px", width: "200px"}}
                    src={"/trendsoft_logo_neue_farbe.png"}
                    alt="zur Startseite"/></div>
                </NavLink>
                {console.log("shop.config.logo",shop.config)}
          </Menu.Item>

          {<Menu.Item style={{ display: "flex", alignItems: "center", position: "relative" }}
            onMouseEnter={shop.config.plugin.categoryHeaderDropdown ? () => { onMegaMenuToggle(); } : undefined}
            onMouseLeave={shop.config.plugin.categoryHeaderDropdown ? () => { onMegaMenuToggle(); } : undefined}
          >
            <Button
              style={{
                backgroundColor: "transparent",
                minWidth: "200px",
                maxWidth: "250px",
                height: "40px",
                alignContent: "center",
                display: "flex",
                alignItems: "center",
                transition: "background 0.2s",
                boxShadow: "none"
              }}
              primary
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = "#f1f1f1ff";
                e.currentTarget.style.zIndex = "9999";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.boxShadow = "none"
              }}
              onClick={shop.config.plugin.categoryHeaderDropdown ? () => onMegaMenuToggle() : app.sidebarLeft.toggle.dispatch}
            >{/*() => this.setState({ siderbarActive: !siderbarActive }) */}
              <div className="black-50 fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                {/*<Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-50 bars" /> */}
                {translate("Alle Kategorien")}
                {shop.config.plugin.categoryHeaderDropdown && <Icon className="" style={{ display: "flex", alignItems: "center", marginLeft: 8 }} name="angle down" />}
              </div>
            </Button>
            {shop.config.plugin.categoryHeaderDropdown && megaMenuActive && <div
              style={{
                backgroundColor: "transparent",
                position: "absolute",
                top: "100%",
                left: 0,
              }}
            ><MegaMenuBigDropDown /></div>}
          </Menu.Item>}
          <Menu.Menu position="right">
          <Menu.Item position="right">
              <Button as={Link} to="/collection/300" primary id="HeaderButtonV3">
                <p className="black-50 fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                  {translate("Angebote")}
                </p>
              </Button>
            </Menu.Item>
          <Menu.Item position="right">
              <Button as={Link} to="/collection/600" primary id="HeaderButtonV3">
                <p className="black-50 fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                  {translate("Entdecken")}
                </p>
              </Button>
            </Menu.Item>
                      <Menu.Item position="right">
              <Button as={Link} to="/customer_contact" primary id="HeaderButtonV3">
                <p className="black-50 fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                  {translate("Kontakt")}
                </p>
              </Button>
            </Menu.Item>
          <Responsive maxWidth={899}>
            <Menu.Item style={{borderRadius: "50px"}}>
              <Button className="ButtonHeader" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
            </Menu.Item>
          </Responsive>
          <Responsive minWidth={900}>
          {<Menu.Item style={{borderRadius: "50px"}}
            position="right">
              <Button id="HeaderSearchV3" primary style={{width: "60px", height: "40px", borderRadius: "20px", }}
               as={Link} to={`/search/?referrer=${document.location.pathname}`}><p><Icon  className="" name="big search "  style={{color: "#646363ff"}} /></p></Button>
            </Menu.Item>}
              </Responsive>

          </Menu.Menu>
          {/* RIGHT SIDE MENU*/}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<Menu.Item>
            <CartButton style={{backgroundColor: "#a2cf66", width: "auto", height: "40px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></Menu.Item>}

          
          {/*!shop.session && <LoginLink/>*/}
          {!shop.session && <Menu.Item> <LoginLinkHover located={"HeaderMenu"}/></Menu.Item>}
          {/*shop.session && <Menu.Item><CartTotalMinimum located={"HeaderMenu"}/></Menu.Item>*/}
          {/*shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/>*/}

          </Menu>
          </Container>
        </div>

        </OnOffset>
        {/*<MenuUtility list={list}/>*/}
        
      </div>)
    }

    return (
      <div >
        <div className="" style={{ backgroundColor: "#646363ff"}} >
          <Container className="flex flex-row justify-between items-center" >
            <SettingsMenu  attached/>
          </Container>
        </div>
        
        <OnOffset
          offset={95}
          onPassedReverse={() => {
            this.setState( { showMini: false } )
          }}
          onPassed={() => {
            this.setState( { showMini: "scrolled" } )
          }}>

        <div className="pt2 pb3" style={{backgroundColor: "#646363ff", }} >
          <Container className="flex flex-row justify-between items-center mb3"  style={{ borderRadius: "0px", backgroundColor: "#ffffff",  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.4)",  zIndex: 1000}} >
          <Menu secondary 
            borderless
            fluid
            size="small">
          {/* LEFT SIDE MENU */}
          <Menu.Item>
          <NavLink to="/home/" className={"Logo"}>
                  <div className="pt2"><img style={{height: "80px", width: "250px"}}
                    src={"/trendsoft_logo_neue_farbe.png"}
                    alt="zur Startseite"/></div>
                </NavLink>
                {console.log("shop.config.logo",shop.config)}
          </Menu.Item>
          {/*<Menu.Item>
            <Menu.Item>
            <table>
              <tbody>
                <tr>
                  <td className="white pb2 f5 tc">
                    Order Mode
                  </td>
                  <td className="white pb2 f5">
                    wählen:
                  </td>
                </tr>
                <tr>
                  <td className="">
                    {console.log("shop.chooseOrderMode",shop.chooseOrderMode)}
                  <Button className="buttonLaboratory" 
                  style={{border: "1px solid #ffffff",
                     backgroundColor: settingStore.get("orderMode") === "laboratory" ? "#a2cf66" : "ffffff",
                    color: settingStore.get("orderMode") === "laboratory" ? "#ffffff" : "#111111",

                  }} onClick={() => { 
              shop.chooseOrderMode = "laboratory"; 
              settingStore.set("orderMode", "laboratory")
              this.setState({ buttonClicked: true });
              this.setState({ orderModeChosen: "laboratory" });
              document.querySelector('.buttonLaboratory').style.backgroundColor = '#a2cf66';
              document.querySelector('.buttonLaboratory').style.color = ' #ffffff';
              document.querySelector('.buttonMedicine').style.backgroundColor = '#ffffff';
              document.querySelector('.buttonMedicine').style.color = ' #111111';
              onClose(); 
            }} ><p className="fw9">Labor</p></Button>
                  </td>
                  <td>
                  <Button className="buttonMedicine" style={{border: "1px solid #ffffff",
                     backgroundColor: settingStore.get("orderMode") === "medicine" ? "#a2cf66" : "ffffff",
                    color: settingStore.get("orderMode") === "medicine" ? "#ffffff" : "#111111",
                    
                  }}  onClick={() => { 
              shop.chooseOrderMode = "medicine"; 
              settingStore.set("orderMode", "medicine")
              this.setState({ buttonClicked: true });
              this.setState({ orderModeChosen: "medicine" });
              document.querySelector('.buttonLaboratory').style.backgroundColor = '#ffffff';
              document.querySelector('.buttonLaboratory').style.color = ' #111111';
              document.querySelector('.buttonMedicine').style.color = ' #ffffff';
              document.querySelector('.buttonMedicine').style.backgroundColor = '#a2cf66';
              onClose(); 
            }}><p className="fw9">Medizin</p></Button>
                  </td>
                </tr>
              </tbody>
            </table>
            </Menu.Item>
          </Menu.Item>*/}
          {<Menu.Item style={{ display: "flex", alignItems: "center", position: "relative" }}
            onMouseEnter={shop.config.plugin.categoryHeaderDropdown ? () => { if(!megaMenuActive) onMegaMenuToggle(); } : undefined}
            onMouseLeave={shop.config.plugin.categoryHeaderDropdown ? () => { if(megaMenuActive) onMegaMenuToggle(); } : undefined}
          >
            <Button
              style={{
                backgroundColor: "#a2cf66",
                minWidth: "150px",
                maxWidth: "200px",
                height: "40px",
                borderRadius: "0px",
                alignContent: "center",
                display: "flex",
                alignItems: "center",
                transition: "background 0.2s",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"
              }}
              primary
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor = "#8fc75f"; // 20% darker than #a2cf66
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor = "#a2cf66";
              }}
              onClick={shop.config.plugin.categoryHeaderDropdown ? () => onMegaMenuToggle() : app.sidebarLeft.toggle.dispatch}
            >
              <div className=" fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="white  bars" />
                {translate("Alle Kategorien")}
              </div>
            </Button>
            {shop.config.plugin.categoryHeaderDropdown && megaMenuActive && <div
              style={{ position: "absolute", top: "100%", left: 0 }}
            ><MegaMenuBigDropDown /></div>}
          </Menu.Item>}
          <Responsive maxWidth={899}>
            <Menu.Item style={{borderRadius: "50px"}}>
              <Button className="ButtonHeader" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
            </Menu.Item>
          </Responsive>
          <Responsive minWidth={900}>
          {<Menu.Item style={{borderRadius: "50px"}}
            position="right">
                <div className="tc " style={{borderRadius: "0px",border: "2px solid #c9c9c9ff",}}>                       <SearchForm
                  style={{ width: "200px", }}
                  className={"mw6 w-100 "}
                  value={searchStore.searchTerm}
                  onChange={e => {
                    searchStore.setSearchTerm( e.target.value )
                  }} icon="search" placeholder={translate( "Suche" ) + "..."}/></div>
            </Menu.Item>}
              </Responsive>

          
          {/* RIGHT SIDE MENU*/}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<Menu.Item>
            <CartButton style={{backgroundColor: "#a2cf66", width: "auto", height: "40px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></Menu.Item>}

          
          {/*!shop.session && <LoginLink/>*/}
          {!shop.session && <Menu.Item> <LoginLinkHover located={"HeaderMenu"}/></Menu.Item>}
          {/*shop.session && <Menu.Item><CartTotalMinimum located={"HeaderMenu"}/></Menu.Item>*/}
          {/*shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/>*/}

          </Menu>
          </Container>
        </div>

        </OnOffset>
        {/*<MenuUtility list={list}/>*/}
        {/*<MegaMenuBig /> */}
      </div>
    )
    }
  }
}

const MiniHeaderMobile = () => <div style={{zIndex: "100"}}
  className={`${shop.config.plugin.MobileHeaderV2 ? "mini-header-V2  animate  fadeInOutUp" : "mini-header  animate  fadeInOutDown"}`} >
    {console.log("shop.config.plugin.MobileHeaderV2", shop.config.plugin.MobileHeaderV2)}
      <div className=" ">
        <div className="pa1 ph2 ph2-ns pt3-ns pb3-ns">
          <div className="flex flex-row justify-between items-center ">
            <div className={"w-70 flex flex-row justify-start pr4 pb3 pt3"}>
              <Button className="ButtonFooter" style={{backgroundColor: "transparent"}} as="a"><Icon className="IconCss" onClick={app.sidebarLeft.toggle.dispatch} name="big bars" /></Button>
              {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
              <Button className="ButtonFooter" as={Link} to={`/account/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big user circle" /></Button>}
              {((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) &&
              <Button className="ButtonFooter" as={Link} to={`/login/?referrer=${document.location.pathname}`}><Icon className="IconCss"  name="big user circle" /></Button>}
            </div>
            
            <div className={"w-50 flex flex-row items-center justify-center"}>
              <Image className="pt3"  style={{height: "60px", width: "60px"}} as={Link} to={"/home/"} src={shop.config.logo} />
            </div>
            
            <div className={"w-70 flex flex-row justify-end items-center pr4 pb3 pt3"}>
              {/*<Search />*/}
              <Button className="ButtonFooter" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
              <Button className="ButtonFooter" as={Link} to={shop.session ?  `/checkout/?referrer=${document.location.pathname}` : `/login/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big shopping cart" /></Button>
            </div>
          </div>
        </div>
      </div>
</div>

const MiniHeaderMobileQuickOrder = () => <div className="mini-header-quickorder MobileHeader_QuickOrderPlus">
  {console.log("Rendering Header for QuickOrderPlus MOBILE")}
                    <Container className="QuickOrderPlusHeader_Container" >
            <div className="QuickOrderPlusHeader_Container">
              <Link to={`/quickorder/`}>
              <ImageWithFallback className="QuickOrderPlusHeader_Logo" style={{width: "150px"}} src={shop.config.logo} fallback={"/trendsoft_logo_neue_farbe.png"} />
              </Link>
              {shop.session && <div><Link to={`/account/`}>
              <Button
              style={{ backgroundColor: "transparent", width: "45px",  height: "45px", borderRadius: "0px", alignContent: "center", display: "flex", alignItems: "center"}}
            >
              <div className=" fw5 f5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-60 large user circle" />
                
              </div>
            </Button></Link></div>}
                            {shop.session && <div><Link to={`/quickorder/`}>
              <Button
              style={{ backgroundColor: "transparent", width: "45px",  height: "45px", borderRadius: "0px", alignContent: "center", display: "flex", alignItems: "center"}}
            >
              <div className=" fw5 f5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-60 large shopping bag" />
                
              </div>
            </Button></Link></div>}
                                          {shop.session && <div>
              <Button
              style={{ backgroundColor: "transparent", width: "45px",  height: "45px", borderRadius: "0px", alignContent: "center", display: "flex", alignItems: "center"}}
            >
              <div className=" fw5 f5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-60 large shopping basket" />
                
              </div>
            </Button></div>}
            </div>

          </Container>
        </div>

const MiniHeader = observer(
  ( props ) => {
    console.log("this.props.showMini", props)
    if(shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme == "QuickOrderPlus"){
      console.log("Rendering Header for QuickOrderPlus MINI")
      return (<div className="mini-header-quickOrder">
        <div className="QuickOrderPlusHeader">
          <Container className="QuickOrderPlusHeader_Container" >
            <div className="QuickOrderPlusHeader_Container"><Link to={`/quickorder/`}><ImageWithFallback className="QuickOrderPlusHeader_Logo" style={{width: "250px", height: "30px"}} src={shop.config.logo} fallback={"/trendsoft_logo_neue_farbe.png"} /></Link>
              {shop.session && <div><Link to={`/account/`}>
              <Button
              style={{
                backgroundColor: "#929292",
                width: "180px",
                height: "45px",
                borderRadius: "0px",
                alignContent: "center",
                display: "flex",
                alignItems: "center",
                transition: "background 0.2s",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"
              }}
              primary
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor = "#8fc75f"; // 20% darker than #a2cf66
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor = "#929292";
              }}
            >{/*() => onSidebarToggle() */}
              <div className=" fw5 f5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="pr2" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="user circle" />
                {translate("Account")}
              </div>
            </Button></Link></div>}
                            {shop.session && <div><Link to={`/quickorder/`}>
              <Button
              style={{
                backgroundColor: "#929292",
                width: "180px",
                height: "45px",
                borderRadius: "0px",
                alignContent: "center",
                display: "flex",
                alignItems: "center",
                transition: "background 0.2s",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"
              }}
              primary
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor = "#8fc75f"; // 20% darker than #a2cf66
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor = "#929292";
              }}
            >{/*() => onSidebarToggle() */}
              <div className=" fw5 f5" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                <Icon className="pr2" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="shopping basket" />
                {translate("Quickorder")}
              </div>
            </Button></Link></div>}
              {shop.session && <div><CartButton style={{backgroundColor: "#a2cf66", width: "180px", height: "45px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></div>}
            </div>

          </Container>
        </div>
        </div>
      )
    }
    else{
    if(shop.config.plugin.HeaderV4){
      //console.log("Rendering Header for HeaderV4 MINI")
    }
    if(shop.config.plugin.HeaderV1){
      return (<div className="mini-header">
    <div className="ph2">
      <Container className="flex flex-row justify-end items-end pa3" >
          <div className="flex flex-row justify-between items-center mini-header-div" style={{borderRadius: "0px", backgroundColor: "#ffffff",  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.4)"}}  >
                        <Menu secondary 
              borderless
              fluid
              size="small">
            {/* LEFT SIDE MENU */}
            <Menu.Item>
            <NavLink to="/home/" className={"Logo"}>
                    <div className="mt2"><img style={{height: "80px", width: "250px"}}
                      src={"/trendsoft_logo_neue_farbe.png"}
                      alt="zur Startseite"/></div>
                  </NavLink>
                  {console.log("shop.config.logo",shop.config)}
            </Menu.Item>
            {/*<Menu.Item>
              <Menu.Item>
              <table>
                <tbody>
                  <tr>
                    <td className="white pb2 f5 tc">
                      Order Mode
                    </td>
                    <td className="white pb2 f5">
                      wählen:
                    </td>
                  </tr>
                  <tr>
                    <td className="">
                      {console.log("shop.chooseOrderMode",shop.chooseOrderMode)}
                    <Button className="buttonLaboratory" 
                    style={{border: "1px solid #ffffff",
                      backgroundColor: settingStore.get("orderMode") === "laboratory" ? "#a2cf66" : "ffffff",
                      color: settingStore.get("orderMode") === "laboratory" ? "#ffffff" : "#111111",

                    }} onClick={() => { 
                shop.chooseOrderMode = "laboratory"; 
                settingStore.set("orderMode", "laboratory")
                this.setState({ buttonClicked: true });
                this.setState({ orderModeChosen: "laboratory" });
                document.querySelector('.buttonLaboratory').style.backgroundColor = '#a2cf66';
                document.querySelector('.buttonLaboratory').style.color = ' #ffffff';
                document.querySelector('.buttonMedicine').style.backgroundColor = '#ffffff';
                document.querySelector('.buttonMedicine').style.color = ' #111111';
                onClose(); 
              }} ><p className="fw9">Labor</p></Button>
                    </td>
                    <td>
                    <Button className="buttonMedicine" style={{border: "1px solid #ffffff",
                      backgroundColor: settingStore.get("orderMode") === "medicine" ? "#a2cf66" : "ffffff",
                      color: settingStore.get("orderMode") === "medicine" ? "#ffffff" : "#111111",
                      
                    }}  onClick={() => { 
                shop.chooseOrderMode = "medicine"; 
                settingStore.set("orderMode", "medicine")
                this.setState({ buttonClicked: true });
                this.setState({ orderModeChosen: "medicine" });
                document.querySelector('.buttonLaboratory').style.backgroundColor = '#ffffff';
                document.querySelector('.buttonLaboratory').style.color = ' #111111';
                document.querySelector('.buttonMedicine').style.color = ' #ffffff';
                document.querySelector('.buttonMedicine').style.backgroundColor = '#a2cf66';
                onClose(); 
              }}><p className="fw9">Medizin</p></Button>
                    </td>
                  </tr>
                </tbody>
              </table>
              </Menu.Item>
            </Menu.Item>*/}
            {<Menu.Item style={{ display: "flex", alignItems: "center", position: "relative" }}
              onMouseEnter={shop.config.plugin.categoryHeaderDropdown ? () => { if(!props.megaMenuActiveMini) props.onMegaMenuToggle(); } : undefined}
              onMouseLeave={shop.config.plugin.categoryHeaderDropdown ? () => { if(props.megaMenuActiveMini) props.onMegaMenuToggle(); } : undefined}
            >
              <Button
                style={{
                  backgroundColor: "#a2cf66",
                  minWidth: "150px",
                  maxWidth: "200px",
                  height: "40px",
                  borderRadius: "0px",
                  alignContent: "center",
                  display: "flex",
                  alignItems: "center",
                  transition: "background 0.2s",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"
                }}
                primary
                onMouseOver={e => {
                  e.currentTarget.style.backgroundColor = "#8fc75f"; // 20% darker than #a2cf66
                }}
                onMouseOut={e => {
                  e.currentTarget.style.backgroundColor = "#a2cf66";
                }}
                onClick={shop.config.plugin.categoryHeaderDropdown ? props.onMegaMenuToggle : app.sidebarLeft.toggle.dispatch}
              >
                <div className=" fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                  <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="white  bars" />
                  {translate("Alle Kategorien")}
                </div>
              </Button>
              {shop.config.plugin.categoryHeaderDropdown && props.megaMenuActiveMini && <div
                style={{ position: "absolute", top: "100%", left: 0 }}
              ><MegaMenuBigDropDown miniHeader={true}/></div>}
            </Menu.Item>}
            <Responsive maxWidth={899}>
              <Menu.Item style={{borderRadius: "50px"}}>
                <Button className="ButtonHeader" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
              </Menu.Item>
            </Responsive>
            <Responsive minWidth={900}>
            {<Menu.Item style={{borderRadius: "50px"}}
              position="right">
                  <div className="tc " style={{borderRadius: "0px",border: "2px solid #c9c9c9ff",}}>                       <SearchForm
                    style={{ width: "200px", }}
                    className={"mw6 w-100 "}
                    value={searchStore.searchTerm}
                    onChange={e => {
                      searchStore.setSearchTerm( e.target.value )
                    }} icon="search" placeholder={translate( "Suche" ) + "..."}/></div>
              </Menu.Item>}
                </Responsive>

            
            {/* RIGHT SIDE MENU*/}
            {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<Menu.Item>
              <CartButton style={{backgroundColor: "#a2cf66", width: "auto", height: "40px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></Menu.Item>}

            
            {/*!shop.session && <LoginLink/>*/}
            {!shop.session && <Menu.Item> <LoginLinkHover located={"HeaderMenu"}/></Menu.Item>}
            {/*shop.session && <Menu.Item><CartTotalMinimum located={"HeaderMenu"}/></Menu.Item>*/}
            {shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/>}

            </Menu>
          </div>
        </Container>
    </div>
  </div>)
    }
    
    if(shop.config.plugin.HeaderV2){
      return (<div className="mini-header mt2 mb2">
    <div className="ph2 pt3 pb3 mini-header-Lindt" style={{borderRadius: "0px", backgroundColor: "#ffffff",  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.4)"}}>

        


      <Container >
          <div   >
                        <div secondary  className="headerMenuLindt pt2" >
            {/* LEFT SIDE MENU */}
            <div>
            <NavLink to="/home/" className={"Logo"}>
                    <div className="mt2"><img style={{height: "20px", width: ""}}
                      src={shop.config.logo}
                      alt="zur Startseite"/></div>
                  </NavLink>
            </div>

            {/*  <Menu.Item style={{ display: "flex", alignItems: "center", position: "relative" }}
              onMouseEnter={shop.config.plugin.categoryHeaderDropdown ? () => { if(!props.megaMenuActiveMini) props.onMegaMenuToggle(); } : undefined}
              onMouseLeave={shop.config.plugin.categoryHeaderDropdown ? () => { if(props.megaMenuActiveMini) props.onMegaMenuToggle(); } : undefined}
            >
            {<Button
                className="categoryMenuButton"
                primary
                onClick={shop.config.plugin.categoryHeaderDropdown ? props.onMegaMenuToggle : app.sidebarLeft.toggle.dispatch}
              >
                <div className="black-50 fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                  <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-50  bars" />
                  {translate("Alle Kategorien")}
                </div>
              </Button> }
              {shop.config.plugin.categoryHeaderDropdown && props.megaMenuActiveMini && <div
                style={{ position: "absolute", top: "100%", left: "-50%" }}
              ><MegaMenuBigDropDown miniHeader={true}/></div>}
            </Menu.Item>*/}
          <Responsive maxWidth={899}>
            <div style={{borderRadius: "50px"}}>
              <Button className="ButtonHeader" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
            </div>
          </Responsive>
          <Responsive minWidth={900}>
          {<div className="headerMenuLindtSearch" style={{borderRadius: "50px"}}
            position="right">
                <div className="tc " style={{}}><SearchForm
                  style={{ width: "200px", }}
                  className={"mw6 w-100 "}
                  value={searchStore.searchTerm}
                  onChange={e => {
                    searchStore.setSearchTerm( e.target.value )
                  }} icon="search" placeholder={translate( "Suche" ) + "..."}/></div>
            </div>}
              </Responsive>

            
            {/* RIGHT SIDE MENU*/}
            {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<div>
            <CartButton style={{background: "#343f27", width: "auto", height: "40px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></div>}

            
            {/*!shop.session && <LoginLink/>*/}
            {!shop.session && <div style={{width: "100px"}}> <LoginLinkHover located={"HeaderMenu"}/></div>}
            {/*shop.session && <Menu.Item><CartTotalMinimum located={"HeaderMenu"}/></Menu.Item>*/}
            {shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/>}

            </div>
          </div>
          
        </Container>
    </div>
  </div>)
    }
    if(shop.config.plugin.HeaderV3){
        return (      <div className="mini-header">
          <div className="ph2">
            <Container className="flex flex-row justify-end items-end pa3" >
                <div className="flex flex-row justify-between items-center mini-header-div" style={{borderRadius: "0px", backgroundColor: "#ffffff",  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.4)"}}  >
                <div className="" style={{}} >
            <Container className="flex flex-row justify-between items-center"  style={{  zIndex: 1000}} >
            <Menu secondary 
              borderless
              fluid
              size="small">
            {/* LEFT SIDE MENU */}
            <Menu.Item>
            <NavLink to="/home/" className={"Logo"}>
                    <div className="pt2"><img style={{height: "65px", width: "200px"}}
                      src={"/trendsoft_logo_neue_farbe.png"}
                      alt="zur Startseite"/></div>
                  </NavLink>
                  {console.log("shop.config.logo",shop.config)}
            </Menu.Item>

            {<Menu.Item style={{ display: "flex", alignItems: "center", position: "relative" }}
              onMouseEnter={shop.config.plugin.categoryHeaderDropdown ? () => { props.onMegaMenuToggle(); } : undefined}
              onMouseLeave={shop.config.plugin.categoryHeaderDropdown ? () => { props.onMegaMenuToggle(); } : undefined}
            >
              <Button
                style={{
                  backgroundColor: "transparent",
                  minWidth: "200px",
                  maxWidth: "250px",
                  height: "40px",
                  alignContent: "center",
                  display: "flex",
                  alignItems: "center",
                  transition: "background 0.2s",
                  boxShadow: "none"
                }}
                primary
                onMouseEnter={e => {
                  e.currentTarget.style.backgroundColor = "#f1f1f1ff";
                  e.currentTarget.style.zIndex = "9999";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.boxShadow = "none"
                }}
                onClick={shop.config.plugin.categoryHeaderDropdown ? props.onMegaMenuToggle : app.sidebarLeft.toggle.dispatch}
              >{/*() => this.setState({ siderbarActive: !siderbarActive }) */}
                <div className="black-50 fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                  {/*<Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="black-50 bars" /> */}
                  {translate("Alle Kategorien")}
                  {shop.config.plugin.categoryHeaderDropdown && <Icon className="" style={{ display: "flex", alignItems: "center", marginLeft: 8 }} name="angle down" />}
                </div>
              </Button>
              {shop.config.plugin.categoryHeaderDropdown && props.megaMenuActiveMini && <div
                style={{ position: "absolute", top: "100%", left: 0 }}
              ><MegaMenuBigDropDown miniHeader={true}/></div>}
            </Menu.Item>}
            <Menu.Menu position="right">
            <Menu.Item position="right">
                <Button as={Link} to="/collection/300" primary id="HeaderButtonV3">
                  <p className="black-50 fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                    {translate("Angebote")}
                  </p>
                </Button>
              </Menu.Item>
            <Menu.Item position="right">
                <Button as={Link} to="/collection/600" primary id="HeaderButtonV3">
                  <p className="black-50 fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                    {translate("Entdecken")}
                  </p>
                </Button>
              </Menu.Item>
                        <Menu.Item position="right">
                <Button as={Link} to="/customer_contact" primary id="HeaderButtonV3">
                  <p className="black-50 fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                    {translate("Kontakt")}
                  </p>
                </Button>
              </Menu.Item>
            <Responsive maxWidth={899}>
              <Menu.Item style={{borderRadius: "50px"}}>
                <Button className="ButtonHeader" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
              </Menu.Item>
            </Responsive>
            <Responsive minWidth={900}>
            {<Menu.Item style={{borderRadius: "50px"}}
              position="right">
                <Button id="HeaderSearchV3" primary style={{width: "60px", height: "40px", borderRadius: "20px", }}
                as={Link} to={`/search/?referrer=${document.location.pathname}`}><p><Icon  className="" name="big search "  style={{color: "#646363ff"}} /></p></Button>
              </Menu.Item>}
                </Responsive>

            </Menu.Menu>
            {/* RIGHT SIDE MENU*/}
            {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<Menu.Item>
              <CartButton style={{backgroundColor: "#a2cf66", width: "auto", height: "40px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></Menu.Item>}

            
            {/*!shop.session && <LoginLink/>*/}
            {!shop.session && <Menu.Item> <LoginLinkHover located={"HeaderMenu"}/></Menu.Item>}
            {/*shop.session && <Menu.Item><CartTotalMinimum located={"HeaderMenu"}/></Menu.Item>*/}
            {/*shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/>*/}

            </Menu>
            </Container>
            </div>
            </div>
            </Container>
            </div>

          {/*<MenuUtility list={list}/>*/}
          
        </div>)
      }
    return (<div className="mini-header">
    <div className="ph2">
      <Container className="flex flex-row justify-end items-end pa3" >
          <div className="flex flex-row justify-between items-center mini-header-div" style={{borderRadius: "0px", backgroundColor: "#ffffff",  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.4)"}}  >
                        <Menu secondary 
              borderless
              fluid
              size="small">
            {/* LEFT SIDE MENU */}
            <Menu.Item>
            <NavLink to="/home/" className={"Logo"}>
                    <div className="pt2"><img style={{height: "80px", width: "250px"}}
                      src={"/trendsoft_logo_neue_farbe.png"}
                      alt="zur Startseite"/></div>
                  </NavLink>
                  {console.log("shop.config.logo",shop.config)}
            </Menu.Item>
            {/*<Menu.Item>
              <Menu.Item>
              <table>
                <tbody>
                  <tr>
                    <td className="white pb2 f5 tc">
                      Order Mode
                    </td>
                    <td className="white pb2 f5">
                      wählen:
                    </td>
                  </tr>
                  <tr>
                    <td className="">
                      {console.log("shop.chooseOrderMode",shop.chooseOrderMode)}
                    <Button className="buttonLaboratory" 
                    style={{border: "1px solid #ffffff",
                      backgroundColor: settingStore.get("orderMode") === "laboratory" ? "#a2cf66" : "ffffff",
                      color: settingStore.get("orderMode") === "laboratory" ? "#ffffff" : "#111111",

                    }} onClick={() => { 
                shop.chooseOrderMode = "laboratory"; 
                settingStore.set("orderMode", "laboratory")
                this.setState({ buttonClicked: true });
                this.setState({ orderModeChosen: "laboratory" });
                document.querySelector('.buttonLaboratory').style.backgroundColor = '#a2cf66';
                document.querySelector('.buttonLaboratory').style.color = ' #ffffff';
                document.querySelector('.buttonMedicine').style.backgroundColor = '#ffffff';
                document.querySelector('.buttonMedicine').style.color = ' #111111';
                onClose(); 
              }} ><p className="fw9">Labor</p></Button>
                    </td>
                    <td>
                    <Button className="buttonMedicine" style={{border: "1px solid #ffffff",
                      backgroundColor: settingStore.get("orderMode") === "medicine" ? "#a2cf66" : "ffffff",
                      color: settingStore.get("orderMode") === "medicine" ? "#ffffff" : "#111111",
                      
                    }}  onClick={() => { 
                shop.chooseOrderMode = "medicine"; 
                settingStore.set("orderMode", "medicine")
                this.setState({ buttonClicked: true });
                this.setState({ orderModeChosen: "medicine" });
                document.querySelector('.buttonLaboratory').style.backgroundColor = '#ffffff';
                document.querySelector('.buttonLaboratory').style.color = ' #111111';
                document.querySelector('.buttonMedicine').style.color = ' #ffffff';
                document.querySelector('.buttonMedicine').style.backgroundColor = '#a2cf66';
                onClose(); 
              }}><p className="fw9">Medizin</p></Button>
                    </td>
                  </tr>
                </tbody>
              </table>
              </Menu.Item>
            </Menu.Item>*/}
            {<Menu.Item style={{ display: "flex", alignItems: "center", position: "relative" }}
              onMouseEnter={shop.config.plugin.categoryHeaderDropdown ? () => { if(!props.megaMenuActiveMini) props.onMegaMenuToggle(); } : undefined}
              onMouseLeave={shop.config.plugin.categoryHeaderDropdown ? () => { if(props.megaMenuActiveMini) props.onMegaMenuToggle(); } : undefined}
            >
              <Button
                style={{
                  backgroundColor: "#a2cf66",
                  minWidth: "150px",
                  maxWidth: "200px",
                  height: "40px",
                  borderRadius: "0px",
                  alignContent: "center",
                  display: "flex",
                  alignItems: "center",
                  transition: "background 0.2s",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"
                }}
                primary
                onMouseOver={e => {
                  e.currentTarget.style.backgroundColor = "#8fc75f"; // 20% darker than #a2cf66
                }}
                onMouseOut={e => {
                  e.currentTarget.style.backgroundColor = "#a2cf66";
                }}
                onClick={shop.config.plugin.categoryHeaderDropdown ? props.onMegaMenuToggle : app.sidebarLeft.toggle.dispatch}
              >
                <div className=" fw5 f4" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }} >
                  <Icon className="" style={{ display: "flex", alignItems: "center", margin: 0 }}  name="white  bars" />
                  {translate("Alle Kategorien")}
                </div>
              </Button>
              {shop.config.plugin.categoryHeaderDropdown && props.megaMenuActiveMini && <div
                style={{ position: "absolute", top: "100%", left: 0 }}
              ><MegaMenuBigDropDown miniHeader={true}/></div>}
            </Menu.Item>}
            <Responsive maxWidth={899}>
              <Menu.Item style={{borderRadius: "50px"}}>
                <Button className="ButtonHeader" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
              </Menu.Item>
            </Responsive>
            <Responsive minWidth={900}>
            {<Menu.Item style={{borderRadius: "50px"}}
              position="right">
                  <div className="tc " style={{borderRadius: "0px",border: "2px solid #c9c9c9ff",}}>                       <SearchForm
                    style={{ width: "200px", }}
                    className={"mw6 w-100 "}
                    value={searchStore.searchTerm}
                    onChange={e => {
                      searchStore.setSearchTerm( e.target.value )
                    }} icon="search" placeholder={translate( "Suche" ) + "..."}/></div>
              </Menu.Item>}
                </Responsive>

            
            {/* RIGHT SIDE MENU*/}
            {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<Menu.Item>
              <CartButton style={{backgroundColor: "#a2cf66", width: "auto", height: "40px", borderRadius: "0px", alignContent: "center", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)"}}/></Menu.Item>}

            
            {/*!shop.session && <LoginLink/>*/}
            {!shop.session && <Menu.Item> <LoginLinkHover located={"HeaderMenu"}/></Menu.Item>}
            {/*shop.session && <Menu.Item><CartTotalMinimum located={"HeaderMenu"}/></Menu.Item>*/}
            {shop.session && shop.session.shopuser && shop.session.shopuser.guest && <LoginLink/>}

            </Menu>
          </div>
        </Container>
    </div>
  </div>)
    }
} )


class OnOffset extends Component {
  
  state = {
    passed: false
  }
  
  componentDidMount() {
    window.addEventListener( "scroll", this.handleScroll )
    this.handleScroll()
  }
  
  componentWillUnmount() {
    window.removeEventListener( "scroll", this.handleScroll )
  }
  
  handleScroll = () => {
    let { passed } = this.state
    let { pageYOffset } = window
    if ( pageYOffset > this.props.offset ) {
      if ( !passed ) {
        this.setState( { passed: true } )
        this.props.onPassed && this.props.onPassed()
      }
    } else {
      if ( passed ) {
        this.setState( { passed: false } )
        this.props.onPassedReverse && this.props.onPassedReverse()
      }
    }
  }
  
  render() {
    return this.props.children || null
  }
}


@observer
class MegaMenu extends Component {
  
  state = {
    hover: false,
    index: false
  }
  
  onLeave = () => {
    this.setState( { hover: false } )
    window.setTimeout( () => {
      let { hover } = this.state
      if ( !hover ) this.setState( { index: false } )
    }, 200 )
  }
  
  onHover = ( { index } ) => {
    this.setState( { index, hover: true } )
  }
  
  render() {
    const { categories } = categoryStore
    const { index } = this.state
    const category = shop.categoriesById.get( index )

    
    return <div className="MegaMenu bg-blue relative" style={{ zIndex: 98 }}>
      <Container className="">
        <div className="pb2">
          {categories.length > 0 && <div>
            <Menu inverted attached="bottom" fluid stackable secondary widths={categories.length}>
              {categories.map( category => {
                
                                 if ( category.children.length === 0 ) {
                                   return <Menu.Item as={NavLink} to={`/collection/${category.map_id}/`}>{category.title}</Menu.Item>
                                 }
                
                                 return <Dropdown key={category.map_id} item text={category.title}>
                                   <Dropdown.Menu>
                                     <Menu.Item as={NavLink} to={`/collection/${category.map_id}/`}><b>{category.title}</b></Menu.Item>
                                     {category.children.map( category => {
                                       return <Dropdown.Item as={Link} to={`/collection/${category.map_id}/`}
                                                             key={category.map_id}>{category.title}</Dropdown.Item>
                                     } )}
                                   </Dropdown.Menu>
                                 </Dropdown>
                               }
              )}
            </Menu>
          
          </div>
          }
        
        
        </div>
      
      </Container>
    </div>
  }
}


let isHovering = false


@withRouter
@observer
export class MegaMenuBig extends Component {
  
  state = {
    hover: false,
    index: false,
  }
  
  onLeave = () => {
    isHovering = false
    this.setState( { hover: false } )
    window.setTimeout( () => {
      let { hover } = this.state
      if ( !hover ) this.setState( { index: false } )
    }, 120 )
  }
  
  onHover = ( { index } ) => {
    const DELAY = 300
    isHovering = true
    window.setTimeout( () => {
      if ( isHovering ) this.setState( { index, hover: true } )
    }, DELAY )
  }
  
  render() {
    let { categories } = categoryStore
    const { index } = this.state
    let selectedCategory = shop.categoriesById.get( index )
    //console.log("shop.chooseOrderMode",shop.chooseOrderMode, categories, selectedCategory, index)
    
    /*const filteredCategories = categories.filter(category => 
        (settingStore.get("orderMode") === "laboratory" && category.title === "Labor") || 
        (settingStore.get("orderMode") === "medicine" && category.title === "Medizin")
      );
    let additionalLink = settingStore.get("orderMode") === "laboratory" ? "40" : "49"
    console.log("filteredCategories",filteredCategories, selectedCategory, categories)
    categories = filteredCategories ? filteredCategories[0] ? filteredCategories[0].children : categories : categories  */
    
    return <div className="backgroundMegaMenu">
      <div
            onMouseLeave={this.onLeave}

            className="megaMenuInner" >
            <Container className="">
              <div className="">
                {/*categories.length > 0 &&
                  <div className={"flex flex-row f5 justify-start items-center flex-wrap space-around"}>
                    {categories
                      .map( category => {
                        // console.log( document.location.pathname, `/collection/${category.map_id}/` )
                        const active = document.location.pathname.startsWith( `/collection/${category.map_id}/` ) || selectedCategory && selectedCategory.map_id === category.map_id
                        console.log("category.children",category.children)
                        return <Link key={category.map_id}
                                     onClick={() => {
                                       this.setState( { index: false, hover: false } )
                                     }}
                                     className={` db pv3 pl2 pr2 f5 white nowrap fw5 hover-black space-around  ${active ? "active" : ""}`}
                                     onMouseEnter={( e ) => this.onHover( { index: category.map_id } )}
                                     to={`/collection/${category.map_id}/`}><span className="dib pr2 f6">{category.title}
                             </span>
                        </Link>
                      } )
                    }</div>*/
                    
                }
                {categories.length > 0 &&
                  <div className={"megaMenuCategoryRow relative"}>
                    {categories
                      .map( category => {
                        const active = document.location.pathname.startsWith( `/collection/${category.map_id}/` ) || selectedCategory && selectedCategory.map_id === category.map_id
                            return (
                            <Link
                              key={category.map_id}
                              onClick={() => {
                              this.setState({ index: false, hover: false });
                              }}
                              className={`cssOptima  tc db pv3 f5 nowrap fw6  white flex-grow-1 megaMenuTopCategoryLink ${active ? "active" : ""}`}
                              onMouseEnter={(e) => {
                              this.onHover({ index: category.map_id });

                              }}
                              style={{
                              pointerEvents: this.state.disableHover ? 'none' : 'auto',
                              }}
                              to={`/collection/${category.map_id}/`} ///${additionalLink}
                            >
                              <span className="tc dib pr2 f6 fw7">{category.title}<Icon name="chevron down" className="megaMenuChevron"/></span>
                            </Link>
                            );
                      } )
                    }
                    <div
                      key="contact"
                      onClick={() => {
                      this.setState({ index: false, hover: false });
                      }}
                      className={`cssOptima  tc db pv3 f2 nowrap fw6  black flex-grow-1 megaMenuTopCategoryLink pointer ${index === "contact" ? "active" : ""}`}
                      onMouseEnter={(e) => {
                      this.onHover({ index: "contact" });
                      }}
                      style={{
                      pointerEvents: this.state.disableHover ? 'none' : 'auto',
                      }}
                    >
                      </div>
                    {selectedCategory  && selectedCategory.children.length > 0  && (<Container
                                        style={{
                                          marginTop: "0",
                                          backgroundColor: "",
                                          alignContent: "center",
                                          position: "absolute",
                                          top: "100%",
                                          left: "0",
                                          right: "0",
                                          zIndex: 999,
                                        }}
                                        onMouseLeave={this.onLeave}
                                        className="bg-white animate fadeIn variantsContainer flex-grow-1 megaMenuStyle" >
                              <div className="megaMenuGrid">
                                {selectedCategory.children.map((subCategory) => {
                                const subPath = `/collection/${selectedCategory.map_id}/${subCategory.map_id}/`
                                const active = document.location.pathname.startsWith( subPath )
                                return (
                                <div className="megaMenuColumn" key={subCategory.map_id}>
                                {/*LEVEL II*/}
                                <Link
                                onClick={() => {
                                this.setState({ index: false, hover: false });
                                }}
                                className={`cssOptima megaMenuCategoryLink ${active ? "active" : ""}`}
                                to={subPath}
                                >
                                <span className="megaMenuCategoryTitle">{subCategory.title}</span>
                                </Link>
                                {/*LEVEL III*/}
                                {subCategory.children && subCategory.children.length > 0 &&
                                  <div className="megaMenuSubCategories">
                                    {subCategory.children.map( subSubCategory => {
                                      const subSubPath = `${subPath}${subSubCategory.map_id}/`
                                      return <Fragment key={subSubCategory.map_id}>
                                        <Link
                                          onClick={() => {
                                          this.setState({ index: false, hover: false });
                                          }}
                                          className={`cssOptima megaMenuSubCategoryLink ${document.location.pathname.startsWith( subSubPath ) ? "active" : ""}`}
                                          to={subSubPath}
                                        >
                                          {subSubCategory.title}
                                        </Link>
                                        {/*LEVEL IV*/}
                                        {subSubCategory.children && subSubCategory.children.length > 0 &&
                                          <div className="megaMenuSubSubCategories">
                                            {subSubCategory.children.map( level4Category => {
                                              const level4Path = `${subSubPath}${level4Category.map_id}/`
                                              return <Link
                                                key={level4Category.map_id}
                                                onClick={() => {
                                                this.setState({ index: false, hover: false });
                                                }}
                                                className={`cssOptima megaMenuSubCategoryLink megaMenuSubSubCategoryLink ${document.location.pathname.startsWith( level4Path ) ? "active" : ""}`}
                                                to={level4Path}
                                              >
                                                {level4Category.title}
                                              </Link>
                                            } )}
                                          </div>
                                        }
                                      </Fragment>
                                    } )}
                                  </div>
                                }
                                </div>
                                );
                                })}
                              </div></Container>
                            )}
                  </div>

                }
                   <div className="BotMenuOrtho"></div>
              </div>

            </Container>
          </div>
          <OrderModeSwitch/>
          </div>
    }
  }


@withRouter
@observer
class OrderModeSwitch extends Component {

  changeMode = ( mode ) => {
    const oldMode = settingStore.get( "orderMode" )
    if ( mode === oldMode ) return

    // sweetalert2 v7: swal( {...} ), Option "type", Ergebnis in result.value
    swal( {
      type: "warning",
      title: translate( "Achtung" ),
      html: translate( "confirm_change" ),
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: translate( "Weiter" ),
      cancelButtonText: translate( "Zurück" ),
    } ).then( ( result ) => {
      if ( !result.value ) return
      shop.cart.clear()
      $fetch.clear()
      settingStore.set( "orderMode", mode )
      categoryStore.updateCategories()
      shop.cart.setExtra( "preorder", mode === "MODE_PREORDER" )
      this.props.history.replace( "/" )
    } )
  }

  render() {
    const current = settingStore.get( "orderMode" )
    return <div className="orderModeSwitch">
      {[ "MODE_AVAILABLE", "MODE_PREORDER" ].map( mode =>
        <button key={mode} type="button"
                className={`cssOptima orderModeSwitchButton ${current === mode ? "active" : ""}`}
                onClick={() => this.changeMode( mode )}>
          {translate( mode )}
        </button>
      )}
    </div>
  }
}


@withRouter
@observer
export class MegaMenuBigDropDown extends Component {
  
  state = {
    hover: false,
    index: false,
    showSubCategories: false,
    categoryHovered: null,
  }
  
  onLeave = () => {
    isHovering = false
    this.setState( { hover: false } )
    window.setTimeout( () => {
      let { hover } = this.state
      if ( !hover ) this.setState( { index: false } )
    }, 120 )
  }
  
  onHover = ( { index } ) => {
    const DELAY = 300
    isHovering = true
    window.setTimeout( () => {
      if ( isHovering ) this.setState( { index, hover: true } )
    }, DELAY )
  }
  
  render() {
    let { categories } = categoryStore
    const { index, showSubCategories, categoryHovered} = this.state
    const { miniHeader } = this.props
    let selectedCategory = shop.categoriesById.get( index )
    //console.log("shop.chooseOrderMode",shop.chooseOrderMode, categories, selectedCategory, index)
    
    /*const filteredCategories = categories.filter(category => 
        (settingStore.get("orderMode") === "laboratory" && category.title === "Labor") || 
        (settingStore.get("orderMode") === "medicine" && category.title === "Medizin")
      );
    let additionalLink = settingStore.get("orderMode") === "laboratory" ? "40" : "49"
    console.log("filteredCategories",filteredCategories, selectedCategory, categories)
    categories = filteredCategories ? filteredCategories[0] ? filteredCategories[0].children : categories : categories  */
    
    return <div className="backgroundMegaMenuDropDown" >
            <div
            onMouseLeave={this.onLeave}
            
            className="TopMenuOrtho relative" style={{color: "#ffffff;", zIndex: 99 }}>
            <Container className="">
              <div className="">
                {categories.length > 0 &&
                  <div className={"flex flex-row f5 justify-start items-center flex-wrap space-around"}
                                     >
                    <Container 
                                        style={{
                                          borderRadius: "0px",
                                          marginTop: "", 
                                          alignContent: "center",
                                          position: "absolute",
                                          top: "100%",
                                          padding: miniHeader ? "30px" : "20px",
                                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" 
                                        }}
                                        onMouseLeave={this.onLeave}
                                        className="bg-white animate fadeIn variantsContainer megaMenuStyle" >
                                          <div className="flex flex-row flex-wrap justify-between ">
                    {categories
                      .map( category => {
                        const active = document.location.pathname.startsWith( `/collection/${category.map_id}/` )
                            return (
                                <div className=" relative" key={category.map_id} style={{ flexBasis: "25%" }}>
                                {/*LEVEL II*/}
                                <Link onMouseEnter={(e) => {this.setState({ showSubCategories: true, categoryHovered: category.map_id })}}
                                onClick={() => {
                                this.setState({ index: false, hover: false });
                                }}
                                className={` flex-grow-1  categoryLinkSubs ${
                                active ? "active" : ""
                                }`}
                                to={`/collection/${category.map_id}/`} //${additionalLink}/
                                >
                                <b className="cssOptima pb2 f4 categoryTitle"> 
                                {category.title}
                                {/*<span className="red">({subCategory.sort})</span>*/}
                                </b>
                                <div
                                  style={{ flexBasis: "25%", zIndex: "10000" }}
                                   // onClick={(e) => e.stopPropagation()} Prevent triggering the Link
                                  >
                                  {console.log("subCategory",category)}
                                  {/*<WordPressShopComponent widthOfComponent={true} key={`category-${subCategory.map_id}`} slug={`category-${subCategory.map_id}-megaMenu`}/> */}
                                  {/*<p className="black-50 f6 pt2">
                                      {(() => {
                                        const text = `In der Kategorie ${category.title} finden Sie alle neuen und modernen Artikel um dieses Thema, schauen Sie sich gerne um!`;
                                        return text.length > 60 ? text.slice(0, 57) + "..." : text;
                                      })()}
                                  {/*(`In der Kategorie ${category.title} finden Sie alle neuen und modernen Artikel um dieses Thema, schauen Sie sich gerne um!`).substring(0, 60)*/}{/*category.desc.des.length > 1 ? "..." : "" */} {/*category.desc.des.substring(0, 40) 
                                  </p> */}
                                  </div>
                                  <p className="pt4 black-20 showProducts">
                                  {translate("Produkte ansehen")} ❯
                                  </p>
                                  </Link>
                                  {/*LEVEL III*/}
                                  {shop.config.plugin.showSubCategories && showSubCategories && categoryHovered === category.map_id && <Container
                                        style={{

                                        }} className="bg-white animate fadeIn containerSubCategories" ><div className="flex flex-row flex-wrap relative ">
                                          <div className="absolute top-0 right-0">
                                            <Button style={{width: "50px", backgroundColor: "transparent"}} onClick={() => this.setState({categoryHovered: null})}><Icon className="large close"/> </Button></div>
                                          {category.children
                                            .map( subCategory => {
                                              const active = document.location.pathname.startsWith( `/collection/${category.map_id}/${subCategory.map_id}/` )
                                                  return (
                                                      <div className=" pr3" key={subCategory.map_id} >
                                                      {/*LEVEL II*/}
                                                      <Link
                                                      onClick={() => {
                                                      this.setState({ index: false, hover: false });
                                                      }}
                                                      className={` black nowrap fw6 hover-shadow b--black-20 hover-primary categoryLinkSubs ${
                                                      active ? "active" : ""
                                                      }`}
                                                      to={`/collection/${category.map_id}/${subCategory.map_id}/`} //${additionalLink}/
                                                      >
                                                      <b className="cssOptima pb2 f4 categoryTitle"> 
                                                      {subCategory.title}
                                                      {/*<span className="red">({subCategory.sort})</span>*/}
                                                      </b>
                                                      <div
                                                        style={{ zIndex: "10000" }}
                                                         // onClick={(e) => e.stopPropagation()} Prevent triggering the Link
                                                        >
                                                        {console.log("subCategory",subCategory)}
                                                        {/*<WordPressShopComponent widthOfComponent={true} key={`category-${subCategory.map_id}`} slug={`category-${subCategory.map_id}-megaMenu`}/> */}
                                                      {/*                                                        <p className="black-50 f6 pt2">
                                                            {(() => {
                                                              const text = `In der Kategorie ${category.title} finden Sie alle neuen und modernen Artikel um dieses Thema, schauen Sie sich gerne um!`;
                                                              return text.length > 40 ? text.slice(0, 37) + "..." : text;
                                                            })()}
                                                        </p> */}
                                                        </div>
                                                        <p className="pt4 black-20 showProducts">
                                                        {translate("Produkte ansehen")} ❯
                                                        </p>
                                                        </Link>
                                                        {/*LEVEL III*/}
                                                      </div>
                                                      );
                                            })}
                                  </div></Container>}
                                </div>
                            
                            
                            );
                      } )
                    }</div></Container></div>
                    
                }
                   <div className="BotMenuOrtho"></div>         
              </div>
      
            </Container>
          </div>
          </div>
    }
  }


// WEBPACK FOOTER //
// ./src/theme/lucht-test/components/Header/Header.js